
export default {
  name: 'StarItem',
  props: {
    state: {
      type: String,
      default: 'unselected',
    },
  },
  methods: {
    onRate() {
      this.$emit('rate');
    },
  },
};
